import { Button } from "@chakra-ui/react";
import { IoFilter } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";

type Props = {
  onToggleFilters?: () => void;
  onRefresh?: () => void | Promise<void>;
  onNewFeeGroup?: () => void;
  isLoading?: boolean;
};

const FeeGroupAgentToolbar = (props: Props) => {
  const {
    onToggleFilters,
    onRefresh,
    onNewFeeGroup,
    isLoading = false,
  } = props;

  return (
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h3 className="text-xl font-semibold text-navy-700 dark:text-white">
        Agent Fee Group
      </h3>
      <div className="flex flex-wrap items-center justify-start gap-2 sm:justify-end">
        <Button
          variant="outline"
          leftIcon={<FaPlus size={16} />}
          onClick={onNewFeeGroup}
          className="btn-secondary-green h-9 rounded-md border px-3 text-sm font-semibold tracking-tight shadow-sm"
        >
          Create New Fee Group
        </Button>

        {onToggleFilters && (
          <Button
            variant="outline"
            leftIcon={<IoFilter size={16} />}
            onClick={onToggleFilters}
            className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Filters
          </Button>
        )}
        <Button
          variant="outline"
          leftIcon={<FiRefreshCw size={16} />}
          onClick={onRefresh}
          isDisabled={isLoading}
          className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default FeeGroupAgentToolbar;
